import Vue from 'vue'
import Vuex from 'vuex'
import modulesPaths from '@moeinmdn/mixitweb-front-modules/src/plugin/store'

Vue.use(Vuex)


export default new Vuex.Store({
    modules: {
        ...modulesPaths,
    }
})
